var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#5B73E8",
    fillOpacity: 0.1,
    stroke: "#5B73E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4895_22970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8559 22V20.5069L19.9922 16.2809L21.4537 17.774L17.3174 22H15.8559ZM9 17.9652V16.6349H14.9228V17.9652H9ZM22.2726 16.9373L20.8111 15.4442L21.3634 14.8799C21.4802 14.7607 21.6317 14.701 21.818 14.701C22.0043 14.701 22.1559 14.7607 22.2726 14.8799L22.8249 15.4442C22.9416 15.5635 23 15.7183 23 15.9086C23 16.099 22.9416 16.2538 22.8249 16.3731L22.2726 16.9373ZM9 14.6431V13.3174H18.1056V14.6431H9ZM9 11.3256V10H18.1056V11.3256H9Z",
    fill: "#5B73E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4895_22970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.c7779c793b2e10723d14b207e0217e08.svg";
export { ForwardRef as ReactComponent };